import React from 'react'
import styled from '@emotion/styled'

import { SUI, Dropdown } from 'shared/ui'
import { propFunc } from 'util/functions'

import Icon from './Icon'

const buildOptions = (
  onReplyAll,
  onDirectMessage,
  { isReplyingAllActive, isReplyingDirectActive }
) => {
  return [
    {
      key: 'reply-all',
      text: 'Reply all',
      onClick: onReplyAll,
      value: 'reply-all',
      active: isReplyingAllActive,
    },
    {
      key: 'reply-direct',
      text: 'Direct reply',
      onClick: onDirectMessage,
      value: 'reply-direct',
      active: isReplyingDirectActive,
    },
  ]
}

class SwitcherButton extends React.PureComponent {
  onReplyAll = () => {
    const { doOpenTicketPage, isExpanded, onReplyAllClick } = this.props
    // this switch is a workaround until the old editor is thrown out, at which point we will throw out the second branch and just work on callbacks
    if (onReplyAllClick) {
      onReplyAllClick()
    } else {
      doOpenTicketPage(isExpanded)
    }
  }

  onDirectMessage = () => {
    const {
      isExpanded,
      onDirectMessageClick,
      doOpenReplyDirectPage,
    } = this.props
    if (onDirectMessageClick) {
      onDirectMessageClick()
    } else {
      doOpenReplyDirectPage(isExpanded)
    }
  }

  render() {
    const {
      className,
      isExpanded,
      isReplyingAll,
      isReplyingDirect,
      replyType,
    } = this.props
    let isReplyingAllActive = false
    let isReplyingDirectActive = false
    if (replyType !== undefined) {
      isReplyingAllActive = replyType === 'reply-all'
      isReplyingDirectActive = replyType === 'reply-direct'
    } else {
      isReplyingAllActive = isReplyingAll
      isReplyingDirectActive = isReplyingDirect
    }
    return (
      <SUI>
        <Dropdown
          className={className}
          options={propFunc(
            buildOptions,
            this.onReplyAll,
            this.onDirectMessage,
            {
              isReplyingAllActive,
              isReplyingDirectActive,
              expand: isExpanded,
            }
          )()}
          trigger={
            <Icon
              isReplyingAll={isReplyingAllActive}
              isReplyingDirect={isReplyingDirectActive}
            />
          }
        />
      </SUI>
    )
  }
}

export default styled(SwitcherButton)`
  &&& {
    align-items: center;
    color: ${props => props.theme.color.monochrome.superDark};
    cursor: pointer;
    display: inline-flex;

    &:hover {
      color: ${props => props.theme.color.primary.brand};
    }

    .Icon {
      line-height: 1.38;
    }

    .dropdown {
      &.icon {
        /* SUI override for a bigger caret thats closer to icon */
        font-size: ${props => props.theme.spacing['3']} !important;
        margin-left: ${props => props.theme.spacing['3']} !important;
      }
    }
  }
`
